import { render } from "./event_highlight_promote.vue?vue&type=template&id=b719c63a&scoped=true"
import script from "./event_highlight_promote.vue?vue&type=script&lang=js"
export * from "./event_highlight_promote.vue?vue&type=script&lang=js"

import "./event_highlight_promote.vue?vue&type=style&index=0&id=b719c63a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b719c63a"]])

export default __exports__